export const APIErrorCondition = 'FAILED' || 'TOKEN_EXPIRED' || 'INVALID_TOKEN';
export const RE_EMAIL =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    export const RE_NAME = /[^a-zA-Z\ \.\'\/]/;
    export const RE_Pin= /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/
    export const RE_Pan=/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/
    export const RE_Phone= /^[6-9][0-9]{9}$/
